/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { SortDirection } from '@gh/core-data';
import { GridLayout, GridSortModel } from '@gh/core-ui-grid';
import { CollectionComparator, composeComparators, negateComparator, valueComparator } from '@gh/core-util';

export function layoutComparator(sort: GridSortModel): CollectionComparator<any> {
  const baseComparator = valueComparator(sort.field);
  return sort.direction === SortDirection.Ascending ? baseComparator : negateComparator(baseComparator);
}

/**
 * Creates factor of layout-based comparators.
 * This function is necessary to create comparator for {@link GridLayout} snapshots.
 *
 * @param defaultComp comparator used if layout is not defined or layout does not have sort order defined
 * @param completionComp comparator used if layout comparision treats both entities as equal
 */
export function createLayoutComparatorFactory<T>(defaultComp: CollectionComparator<T>,
                                                 // tslint:disable-next-line:max-line-length
                                                 completionComp: CollectionComparator<T>): (layout?: GridLayout) => CollectionComparator<T> {
  return (layout?: GridLayout) => layout && layout.sort
    ? composeComparators(layoutComparator(layout.sort), completionComp)
    : defaultComp;
}
